export default __webpack_public_path__ + "static/media/17.68f0f299.jpg";